const articlesSearchForm = document.getElementById('articlesSearchForm');
const articlesSearchInput = document.getElementById('searchArticlesInput');
// const articlesSearchButton = document.getElementById('search-articles-button');
const isEmpty = str => !str.trim().length;

articlesSearchForm.addEventListener('submit', function (event) {
    event.preventDefault();
    let action = articlesSearchForm.action;
    if (!isEmpty(articlesSearchInput.value)) {
        if (action.includes('?')) {
            action = action + "&";
        } else {
            action = action + "?";
        }
        action = action + "SearchText=" + articlesSearchInput.value;
    }
    window.location.href = action;
});

